/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const EXTERNAL_USER = 'TICKET_EXTERNAL_USER';
export const INTERNAL_USER = 'TICKET_INTERNAL_USER';

export const ERR_V2_REQUIRED = 'additional challenge required';
export const ERR_TOUR_INSTANCE_CLOSED = 'closed_tour_instance';
export const ERR_RATE_LIMIT_EXCEEDED =
    'retry: We are currently experiencing heavy traffic on our site. Please try again.';
export const ERR_YOU_LOOK_FAMILIAR = 'You look familiar! This facility only allows';
export const ERR_YOU_LOOK_FAMILIAR_TOUR = 'You look familiar! This tour only allows';
export const ERR_BUSY =
    'Too many people are requesting this tour at this time, please try again';
export const ERR_CHALLENGE_FAILED = 'challenge failed';
export const ERR_NO_LONGER_AVAILABLE = 'Looks like this is a popular location';
export const ERR_ADVANCED_RESERVATION =
    'Guest users are not allowed to make advanced reservations';

export const GOLDEN_SPIKE_FACILITY_ID = '10087141';
export const RED_ROCK_FACILITY_ID = '10075177';
export const COCHITI_FACILITY_ID = '10086515';
export const YOSEMITE_TICKETED_ENTRY = '10086745';
export const DENALI_TIMED_ENTRY = '10086913';
export const BRAINARD_LAKE_FACILITY_ID = '10087515';
export const MOUNT_EVANS_FACILITY_ID = '10087438';
export const SAN_GABRIEL_FACILITY_ID = '10086721';
export const ACADIA_FACILITY_ID = '400000';
export const GLACIER_FACILITY_ID = '10087086';
export const ROCKY_MOUNTAIN_SHUTTLE_FACILITY_ID = '10088647';
export const ROCKY_MOUNTAIN_FACILITY_ID = '10086910';
export const LAVA_RIVER_CAVE_FACILITY_ID = '10089508';
export const VALLES_CALDERA_FACILITY_ID = '10089849';
export const ARCHES_FACILITY_ID = '10088426';
export const SNAKE_RIVER_FACILITY_ID = '10112505';

export const isGoldenSpike = (facilityId) => facilityId === GOLDEN_SPIKE_FACILITY_ID;
export const isRedRock = (facilityId) => facilityId === RED_ROCK_FACILITY_ID;
export const isYosemite = (facilityId) => facilityId === YOSEMITE_TICKETED_ENTRY;
export const isCochiti = (facilityId) => facilityId === COCHITI_FACILITY_ID;
export const isDenali = (facilityId) => facilityId === DENALI_TIMED_ENTRY;
export const isBrainardLake = (facilityId) => facilityId === BRAINARD_LAKE_FACILITY_ID;
export const isMountEvans = (facilityId) => facilityId === MOUNT_EVANS_FACILITY_ID;
export const isSanGabriel = (facilityId) => facilityId === SAN_GABRIEL_FACILITY_ID;
export const isSnakeRiver = (facilityId) => facilityId === SNAKE_RIVER_FACILITY_ID;

export const COMMERCIAL_ACCOUNT_TYPE = 'COMM';

export const TIMED_ENTRY_PREFIX = 'TIMED_ENTRY_';

// This is used to determine to the trasition timeout speed of the mobile details panel.
export const TRANSITION_TIMEOUT = 300;

// inventory types
export const INVENTORY_TICKET = 'TICKET';
export const INVENTORY_TIMED_ENTRY = 'TIMED_ENTRY';

// site pass ids
export const GLACIER_SITEPASS_ID = '74280';
export const ROCKY_MOUNTAIN_SITEPASS_ID = '74291';
export const DESCHUTES_SITEPASS_ID = '74418';
export const ACADIA_SITEPASS_ID = '74271';
export const ARCHES_SITE_PASS_ID = '74330';

// infographic data
export const INFOGRAPHIC = {
    [GLACIER_FACILITY_ID]: {
        data: {
            mainTitle: 'Going-to-the-Sun Road or North Fork Areas',
            mainDescription:
                'Trip dates between May 27 - Sept. 11, 2022 To visit these areas,you must have these items.',
            mainLink: 'https://www.nps.gov/glac/planyourvisit/gtsrticketedentry.htm',
            mainLinkLabel: 'Learn More on NPS.gov',
            secondCardFirstStepTitle: 'Vehicle Reservation',
            secondCardFirstStepDescription: 'Only available online.',
            secondCardSecondStepTitle: 'Camping or Activity Reservation',
            secondCardSecondStepDescription:
                "If you have a lodging or activity reservation within this area, you don't need a vehicle reservation.",
            thirdCardTitle: 'Interagency or Park Pass',
            thirdCardDescription: 'Available at entrance station or online',
            buyNowButton: {
                link: `/sitepass/${GLACIER_SITEPASS_ID}`,
                clickTagCategory: 'Pass Upsell Promo',
                clickTagAction: `Location ID - ${GLACIER_FACILITY_ID}`,
                clickTagLabel: 'Buy Now Button',
            },
        },
    },
    [ROCKY_MOUNTAIN_SHUTTLE_FACILITY_ID]: {
        data: {
            mainTitle: 'Plan Your Visit to Rocky Mountain National Park',
            mainDescription:
                'Trip dates between May 27 - Oct 10, 2022 To visit this park, you must have these items.',
            mainLink:
                'https://www.nps.gov/romo/planyourvisit/timed-entry-permit-system.htm',
            mainLinkLabel: 'Learn More on NPS.gov',
            secondCardFirstStepTitle: 'Vehicle Reservation or Shuttle Ticket',
            secondCardFirstStepDescription: 'Only available online.',
            secondCardSecondStepTitle: 'Camping or Activity Reservation',
            secondCardSecondStepDescription:
                "If you have a lodging or activity reservation within this area, you don't need a vehicle reservation.",
            thirdCardTitle: 'Park Pass',
            thirdCardDescription:
                'Available in person at participating locations or online, you can also buy an <a class="infographic__card-link" href="/pass">Interagency Pass</a>',
            buyNowButton: {
                link: `/sitepass/${ROCKY_MOUNTAIN_SITEPASS_ID}`,
                clickTagCategory: 'Pass Upsell Promo',
                clickTagAction: `Location ID - ${ROCKY_MOUNTAIN_SHUTTLE_FACILITY_ID}`,
                clickTagLabel: 'Buy Now Button',
            },
        },
    },
    [ROCKY_MOUNTAIN_FACILITY_ID]: {
        data: {
            mainTitle: 'Plan Your Visit to Rocky Mountain National Park',
            mainDescription:
                'Trip dates between May 27 - Oct 10, 2022 To visit this park, you must have these items.',
            mainLink:
                'https://www.nps.gov/romo/planyourvisit/timed-entry-permit-system.htm',
            mainLinkLabel: 'Learn More on NPS.gov',
            secondCardFirstStepTitle: 'Vehicle Reservation or Shuttle Ticket',
            secondCardFirstStepDescription: 'Only available online.',
            secondCardSecondStepTitle: 'Camping or Activity Reservation',
            secondCardSecondStepDescription:
                "If you have a lodging or activity reservation within this area, you don't need a vehicle reservation.",
            thirdCardTitle: 'Park Pass',
            thirdCardDescription:
                'Available in person at participating locations or online, you can also buy an <a class="infographic__card-link" href="/pass">Interagency Pass</a>',
            buyNowButton: {
                link: `/sitepass/${ROCKY_MOUNTAIN_SITEPASS_ID}`,
                clickTagCategory: 'Pass Upsell Promo',
                clickTagAction: `Location ID - ${ROCKY_MOUNTAIN_FACILITY_ID}`,
                clickTagLabel: 'Buy Now Button',
            },
        },
    },
    [LAVA_RIVER_CAVE_FACILITY_ID]: {
        data: {
            mainTitle: 'Plan Your Visit to Lava River Cave',
            mainDescription:
                'To visit this area with a vehicle, you must have these items',
            mainLink: 'https://www.fs.usda.gov/recarea/deschutes/recarea/?recid=38396',
            mainLinkLabel: 'Learn More on USDA.gov',
            secondCardFirstStepTitle: 'Vehicle Reservation',
            secondCardFirstStepDescription: 'Only available online.',
            hideSecondCardSecondStep: true,
            thirdCardTitle: 'Forest Pass',
            thirdCardDescription:
                'Available in person at participating locations or online, you can also buy an <a class="infographic__card-link" href="/pass">Interagency Pass</a>',
            buyNowButton: {
                link: `/sitepass/${DESCHUTES_SITEPASS_ID}`,
                clickTagCategory: 'Pass Upsell Promo',
                clickTagAction: `Location ID - ${LAVA_RIVER_CAVE_FACILITY_ID}`,
                clickTagLabel: 'Buy Now Button',
            },
        },
    },
};

export const FACILITY_SITEPASS = {
    [ROCKY_MOUNTAIN_FACILITY_ID]: ROCKY_MOUNTAIN_SITEPASS_ID,
    [ROCKY_MOUNTAIN_SHUTTLE_FACILITY_ID]: ROCKY_MOUNTAIN_SITEPASS_ID,
    [GLACIER_FACILITY_ID]: GLACIER_SITEPASS_ID,
    [ACADIA_FACILITY_ID]: ACADIA_SITEPASS_ID,
    [ARCHES_FACILITY_ID]: ARCHES_SITE_PASS_ID,
};

export const HIDDEN_SITE_PASS_TYPES = ['INDIV', 'PEDESTRIAN'];

// links
export const GUEST_CHECKOUT_HELP_LINK = `${process.env.SN_KB_EXT_URL}?id=kb_article&sys_id=fd463b891bd0f550375587bae54bcbdb`;

// agency names
export const NPS_AGENCY = 'NPS';

// Time interval when data becomes stale so we query the api again(for fetching availability)
export const MAX_STALE_TIME = 1 * 60 * 1000; // 1 minute

// facilities that includes first come first served
export const INCLUDE_FIRST_COME_FIRST_SERVED = [];
